const minSize = 2
const maxSize = 80
const inc = 2

export default {
  bind (el) {
    setTimeout(() => {
      let fontSize = minSize
      const parentWidth = el.getBoundingClientRect().width
      let tick = 0
      const items = [...el.querySelectorAll('*')]
      if (!parentWidth) return

      function increaseSize (item) {
        if (fontSize >= maxSize) return
        const itemWidth = item.getBoundingClientRect().width
        if (!itemWidth) return
        if (tick > 200) return
        if ((itemWidth * 1.1) >= parentWidth) return
        fontSize = inc + fontSize
        item.style.fontSize = `${fontSize}px`
        // item.style.letterSpacing = `-${fontSize * 0.01}px`npm
        tick++
        increaseSize(item)
      }

      items.forEach(item => {
        if (!item.innerText.length) return
        item.style.display = 'inline-block'
        item.style.fontSize = `${minSize}px`
        increaseSize(item)
      })
    }, 500)
  },
}


// WEBPACK FOOTER //
// ./src/vue-directives/scale-text-to-fit.js